<mat-sidenav-container>
  <mat-sidenav class="left" disableClose mode="side" opened>
    <div class="tp-sidenav-container left" [ngClass]="{ 'collapsed': leftSidebarCollapsed }" >
      <tp-sidebar (collapsedChange)="leftSidebarCollapsed = $event"/>
    </div>
  </mat-sidenav>

  <mat-sidenav-content [@sidebarLeftMargin]="leftSidebarCollapsed ? 'collapsed' : 'open'">
    @if (displayMFAEncouragementBanner$ | async) {
      <div class="admonitionblock attention mfa-encourage">
        <div>
          <div class="icon">
            <i class="fa-solid fa-triangle-exclamation"></i>
          </div>
          <p>Your team encourages multi-factor authentication. If you do not enable it, your access to team resources may be restricted in the future.</p>
        </div>
        <div class="flex-spacer"></div>
        <a routerLink="/settings" fragment="mfa">
          <tp-button
            buttonId="enableMFA"
            buttonStyle="primary-outline white stroke"
          >Enable MFA</tp-button>
        </a>
      </div>
    }
    @switch (pageAvailability) {
      @case ("ready") {
        <div class="action-bar">
          <ng-content select="[actionBar]"/>
          <div class="flex-spacer"></div>
          <div #novuInbox></div>
          <tp-button buttonId="actionBarSupport" buttonStyle="secondary" (click)="rightSidebar.toggle(undefined, 'mouse')">
            Help
            <i class="fa-light fa-chevron-right"></i>
          </tp-button>
        </div>
        <ng-content/>
      }
      @case ("loading") {
        <tp-spinner/>
      }
      @case (null) {
        <tp-spinner/>
      }
      @default {
      }
    }
  </mat-sidenav-content>

  <mat-sidenav class="right" disableClose #rightSidebar mode="side" position="end">
    <div class="tp-sidenav-container right"><tp-right-sidebar/></div>
  </mat-sidenav>
</mat-sidenav-container>
